import { Box, Container, Divider, Link, Stack, Typography } from "@mui/material";

import MailOutlineIcon from '@mui/icons-material/MailOutline';

const SUPPORT_EMAIL = 'support@dfsopto.com';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        backgroundColor: "primary.main",
        color: "common.white",
        mt: '5rem',
        py: { xs: 3, sm: 4 },
      }}
    >
      <Container maxWidth={false} sx={{ px: { xs: 2, sm: 4, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={{ xs: 2, sm: 0 }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: '0.02em' }}>
            DFS Opto
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <MailOutlineIcon fontSize="small" sx={{ opacity: 0.85 }} />
            <Typography variant="body2" sx={{ opacity: 0.85 }}>
              Contact us:
            </Typography>
            <Link
              href={`mailto:${SUPPORT_EMAIL}`}
              variant="body2"
              underline="hover"
              sx={{ color: 'common.white', fontWeight: 600 }}
            >
              {SUPPORT_EMAIL}
            </Link>
          </Stack>
        </Stack>
        <Divider sx={{ my: 2, borderColor: 'rgba(255, 255, 255, 0.2)' }} />
        <Typography variant="caption" component="p" textAlign="center" sx={{ opacity: 0.7 }}>
          © {new Date().getFullYear()} DFS Opto. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export { Footer };
